import { TextField, TextFieldProps } from '@mui/material';

const inputSx = {
  width: '100%',
  '& .MuiInputBase-root': {
    height: '38px',
    borderRadius: '8px',

    '& fieldset': {
      color: 'var(--primary-color)',
      borderColor: 'var(--secondary-color)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--secondary-color)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--secondary-color)',
    },
    '&.MuiInputBase-multiline': {
      height: 'auto',
    },
    '& .MuiInputBase-input, & .MuiInputBase-inputMultiline': {
      fontFamily: '"Montserrat", sans-serif',
    },
  },
};

const Input = (props: TextFieldProps) => {
  return <TextField {...props} sx={{ ...inputSx, ...props.sx }} />;
};

export { Input };
